module.exports = __webpack_public_path__ + "static/stephanie-wilson-1a8cc821d891abdbc9d07a90d3c2ac26.jpg";